import { useScope } from '../contexts/ScopeContext';
export default function ScopeUnavailable({ source = 'This source' }: { source?: string }) {
  const scope = useScope();
  return <section role="status" className="rounded border border-slate-300 bg-white p-5">
    <h2 className="font-semibold">{scope.label}</h2>
    <p>{source} requires a supported concrete environment. Choose one with the global Environment control.</p>
    <p className="mt-2 text-sm text-slate-500">No DEV default or aggregate result has been substituted.</p>
  </section>;
}
